import React, { useState, useEffect } from "react"
import "./Product.css"
import p1 from "../Images/Products/p1.jpg"
import p2 from "../Images/Products/p2.jpg"
import p3 from "../Images/Products/p3.jpg"
import p4 from "../Images/Products/p4.jpg"
import productVideo from "../videos/Curiokaards.mp4"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { 
  faChevronLeft, faChevronRight, faSquareCheck, 
  faShoppingCart, faAward, faCertificate, faClipboardCheck, 
  faBook, faStar, faUsers, faHome, faChartLine, 
  faTrophy, faGraduationCap, faLightbulb, faBrain,
  faMemory, faHandsHolding, faSmile
} from "@fortawesome/free-solid-svg-icons"

const Product = () => {
  const [currentImage, setCurrentImage] = useState(0)
  const images = [p1, p2, p3, p4]

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImage(prev => (prev === images.length - 1 ? 0 : prev + 1))
    }, 4000)
    return () => clearInterval(timer)
  }, [images.length])

  const handleImageChange = (direction) => {
    setCurrentImage(prev => 
      direction === 'next' 
        ? (prev === images.length - 1 ? 0 : prev + 1)
        : (prev === 0 ? images.length - 1 : prev - 1)
    )
  }

  const features = [
    { icon: faBook, text: "Curriculum-aligned gamified flashcards" },
    { icon: faStar, text: "Points system with bonus points" },
    { icon: faUsers, text: "Individual & group activities" },
    { icon: faHome, text: "Classroom & home use" },
    { icon: faChartLine, text: "Progress tracking scorecard" },
    { icon: faTrophy, text: "Awards for 85%+ scores" },
    { icon: faGraduationCap, text: "Ages 3-7 years (Pre-primary to Class 1)" },
    { icon: faLightbulb, text: "Adjustable difficulty levels" }
  ]

  return (
    <div className="product-sec">
      <div className="title">Our Products</div>
      <div className="curiokaards-container">
        <h2>CurioKAARDS™ – Gamifying Education</h2>
        
        <div className="media-row">
          <div className="image-carousel">
            <button className="carousel-btn prev" onClick={() => handleImageChange('prev')}>
              <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            <img src={images[currentImage]} alt="CurioKAARDS" />
            <button className="carousel-btn next" onClick={() => handleImageChange('next')}>
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
          
          <div className="video-container">
            <video controls className="product-video" playsInline>
              <source src={productVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>

        <div className="content-row">
          <div className="product-description">
            <p className="intro-text">
              CurioKAARDS™ are engaging educational kits designed to spark curiosity in children. Each pack features curriculum-aligned gamified flashcards, where children earn points for correct answers and bonus points for exceptional responses.
            </p>
            <p className="sub-text">
              These kits come with a comprehensive instruction manual and scorecard, making it easier for teachers and parents to guide and track the child's learning journey.
            </p>
          </div>

          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-item">
                <FontAwesomeIcon icon={feature.icon} className="feature-icon" />
                <span>{feature.text}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="content-row">
          <div className="evaluation-info">
            <h3>Key Benefits of Gamified Learning</h3>
            <ul className="benefits-list">
              <li><FontAwesomeIcon icon={faBrain} className="benefit-icon" /> Engages and inspires young minds</li>
              <li><FontAwesomeIcon icon={faMemory} className="benefit-icon" /> Strengthens memory retention</li>
              <li><FontAwesomeIcon icon={faLightbulb} className="benefit-icon" /> Ignites curiosity & creativity</li>
              <li><FontAwesomeIcon icon={faHandsHolding} className="benefit-icon" /> Encourages hands-on, screen-free play</li>
              <li><FontAwesomeIcon icon={faSmile} className="benefit-icon" /> Makes learning fun and exciting</li>
            </ul>
        
            <div className="evaluation-section">
              <h3>Evaluation & Recognition</h3>
              <p>A formal evaluation by educators will be conducted within 45-60 days of kit usage to assess learning outcomes. Children scoring above 85% will receive awards, certificates, and cash prizes.</p>
            </div>
          </div>
        
          <div className="price-section">
            <h3 className="price-title">Price Per Kit</h3>
            <div className="price-options">
              <div className="price-item">
                <FontAwesomeIcon icon={faSquareCheck} className="check-icon" />
                <span className="subject">English</span>
                <span className="amount">₹290</span>
              </div>
              <div className="price-item">
                <FontAwesomeIcon icon={faSquareCheck} className="check-icon" />
                <span className="subject">Maths</span>
                <span className="amount">₹290</span>
              </div>
            </div>
        
            <div className="price-includes">
              <h4>Kit Includes:</h4>
              <div className="includes-grid">
                <div className="include-item">
                  <FontAwesomeIcon icon={faBook} className="include-icon" />
                  <span>15 Engaging Learning Cards</span>
                </div>
                <div className="include-item">
                  <FontAwesomeIcon icon={faLightbulb} className="include-icon" />
                  <span>Gamified Learning Method Guide</span>
                </div>
                <div className="include-item">
                  <FontAwesomeIcon icon={faClipboardCheck} className="include-icon" />
                  <span>Formal Assessments</span>
                </div>
              </div>
              <div className="includes-grid-second-row">
                <div className="include-item">
                  <FontAwesomeIcon icon={faCertificate} className="include-icon" />
                  <span>Certification</span>
                </div>
                <div className="include-item">
                  <FontAwesomeIcon icon={faAward} className="include-icon" />
                  <span>Rewards for Top Scores</span>
                </div>
              </div>
              <p className="includes-note">*Refer to product manual for detailed information about assessments and rewards</p>
            </div>
          </div>
        </div>

        <div className="order-section">
          <a 
            href="https://docs.google.com/forms/d/e/1FAIpQLSe-Yx3JcjL2nNI6vGDPa9oGa4KgIrcea1_m3Z1l_5COdn_Ryg/viewform?usp=sf_link"
            className="order-btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="order-text">Order Now</span>
            <FontAwesomeIcon icon={faShoppingCart} className="cart-icon" />
          </a>
        </div>
      </div>
    </div>
  )
}

export default Product